import { translate } from '@/domains/core/localization/translate';
export const {
  leonidasMenuSeeAll,
  leonidasMenuYouAreViewing
} = translate({
  "leonidasMenuSeeAll": "See all",
  "leonidasMenuYouAreViewing": "You're looking at"
});